import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import { addressSchema, addressListSchema } from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/addresses/actions';
import { AddressesActionTypes as types } from 'app/ducks/addresses/types';

function* createAddressSaga(action): any {
  yield put(sagaActions.createAddressPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).teamAddresses.create(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, addressSchema);

    yield put(sagaActions.createAddressSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createAddressFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* updateAddressSaga(action): any {
  yield put(sagaActions.updateAddressPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).teamAddresses.update(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, addressSchema);

    yield put(sagaActions.updateAddressSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateAddressFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* getAddressSaga(action): any {
  yield put(sagaActions.getAddressPending());
  const [error, response] = yield (yield TeammoApi(yield select())).teamAddresses.show(
    action.payload,
  );
  if (response) {
    const normalizedResponse = normalize(response, addressSchema);
    yield put(sagaActions.getAddressSuccess(normalizedResponse));
    return normalizedResponse.entities.addresses[normalizedResponse.result];
  }
  yield put(
    handleError(error, sagaActions.getAddressFailed(_.isEmpty(error) ? {} : error.response.data.errors)),
  );
  return null;
}

function* getAllAddressesSaga(action): any {
  yield put(
    sagaActions.getAllAddressesPending(action.payload.compile ? action.payload.pagination : {}),
  );
  yield put(loadingStart());

  const paginationObject = action.payload.compile
    ? compilePaginationObject(yield select((state) => state.addresses.pagination))
    : action.payload.pagination;

  const [error, response] = yield (yield TeammoApi(yield select())).teamAddresses.list(
    paginationObject,
  );

  if (response) {
    const normalizedResponse = normalize(response, addressListSchema);

    yield put(
      sagaActions.getAllAddressesSuccess(normalizedResponse, response.meta),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllAddressesFailed(_.isEmpty(error) ? {} : error.response.data.errors),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createAddressSagaWatcher(): any {
  yield takeLatest(types.CREATE_ADDRESS_REQUESTED, createAddressSaga);
}

function* updateAddressSagaWatcher(): any {
  yield takeLatest(types.UPDATE_ADDRESS_REQUESTED, updateAddressSaga);
}

function* getAddressSagaWatcher(): any {
  yield takeEvery(types.GET_ADDRESS_REQUESTED, getAddressSaga);
}

function* getAllAddressesSagaWatcher(): any {
  yield takeEvery(types.GET_ALL_ADDRESSES_REQUESTED, getAllAddressesSaga);
}

export default function* root(): any {
  yield all([
    createAddressSagaWatcher(),
    updateAddressSagaWatcher(),
    getAddressSagaWatcher(),
    getAllAddressesSagaWatcher(),
  ]);
}
